import { render } from "./Class.vue?vue&type=template&id=73fe86ec&scoped=true"
import script from "./Class.vue?vue&type=script&lang=js"
export * from "./Class.vue?vue&type=script&lang=js"

import "./Class.vue?vue&type=style&index=0&id=73fe86ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fe86ec"]])

export default __exports__